import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronRightDouble14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M7.08074 7.01001L3.55041 3.47968L2.48975 4.54034L4.95942 7.01001L2.48975 9.47968L3.55041 10.5403L7.08074 7.01001Z'
      fill='currentColor'
    />
    <path
      d='M12.0807 7.01001L8.55041 3.47968L7.48975 4.54034L9.95942 7.01001L7.48975 9.47968L8.55041 10.5403L12.0807 7.01001Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronRightDouble14.displayName = 'ChevronRightDouble14';
export default ChevronRightDouble14;
